/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RegistrationSearchQueryDto { 
    search?: string;
    view?: RegistrationSearchQueryDto.ViewEnum;
}
export namespace RegistrationSearchQueryDto {
    export const ViewEnum = {
        sync_failed: 'sync-failed',
        to_register: 'to-register'
    } as const;
    export type ViewEnum = typeof ViewEnum[keyof typeof ViewEnum];
}


